<template>
	<div class="login-view">
		<!-- 背景光斑/装饰 -->
		<div class="bg-orb orb-1"></div>
		<div class="bg-orb orb-2"></div>
		<div class="bg-orb orb-3"></div>

		<div class="content">
			<div class="login-card">
				<div class="card-left">
					<div class="left-top">
						<div class="welcome">WELCOME</div>
						<div class="welcome-line"></div>
					</div>

					<div class="left-hero">
						<div class="hero-surface"></div>
						<div class="hero-fig"></div>
						<div class="hero-fig hero-fig-2"></div>
					</div>

					<div class="left-bottom">
						<div class="left-title shimmer">{{ leftTitle }}</div>
						<div class="left-sub">欢迎加入</div>
					</div>
				</div>

				<div class="card-right">
					<div class="right-header">
						<img v-if="displayLogo" class="right-icon icon-float" :src="displayLogo" alt="" />
						<div class="right-title shimmer">{{ rightTitle }}</div>
					</div>

					<div class="right-subtitle">账号登录</div>

					<el-form class="form" :model="loginForm" status-icon :rules="rules" ref="loginForm"
						@keyup.enter.native="submitForm('loginForm')">
						<el-form-item prop="terminal" v-show="false">
							<el-input type="terminal" v-model="loginForm.terminal" autocomplete="off"></el-input>
						</el-form-item>
						<el-form-item prop="userName">
							<el-input class="im-input" v-model="loginForm.userName" autocomplete="off" placeholder="请输入账号"
								prefix-icon="el-icon-user"></el-input>
						</el-form-item>
						<el-form-item prop="password">
							<el-input class="im-input" type="password" v-model="loginForm.password" autocomplete="off"
								placeholder="请输入密码" prefix-icon="el-icon-lock"></el-input>
						</el-form-item>
						<el-form-item class="btn-row">
							<el-button class="btn-login" type="primary" @click="submitForm('loginForm')">立即登录</el-button>
						</el-form-item>
					</el-form>
				</div>
			</div>
		</div>
		<icp></icp>
	</div>
</template>

<script>
import Icp from '../components/common/Icp.vue'
export default {
	name: "login",
	components: {
		Icp
	},
	data() {
		var checkUsername = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('请输入用户名'));
			}
			callback();
		};
		var checkPassword = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请输入密码'));
			}
			callback();

		};
		return {
			defaultTitle: '乐聊员工系统',
			defaultLogo: '/logo.png',
			tenantName: '',
			tenantLogo: '',
			loginForm: {
				terminal: this.$enums.TERMINAL_TYPE.WEB,
				userName: '',
				password: '',
				tenantId: null
			},
			rules: {
				userName: [{
					validator: checkUsername,
					trigger: 'blur'
				}],
				password: [{
					validator: checkPassword,
					trigger: 'blur'
				}]
			}
		};
	},
	computed: {
		leftTitle() {
			return this.displayTitle || this.defaultTitle;
		},
		rightTitle() {
			return (this.displayTitle || this.defaultTitle)+"·登录";
		},
		displayTitle() {
			return this.tenantName || "";
		},
		displayLogo() {
			return this.tenantLogo || this.defaultLogo;
		}
	},
	methods: {
		submitForm(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.$http({
						url: "/login",
						method: 'post',
						data: this.loginForm
					})
						.then((data) => {
							// 保存密码到cookie(不安全)
							this.setCookie('username', this.loginForm.userName);
							this.setCookie('password', this.loginForm.password);
							// 保存token
							sessionStorage.setItem("accessToken", data.accessToken);
							sessionStorage.setItem("refreshToken", data.refreshToken);
							this.$message.success("登录成功");
							this.$router.push("/home/chat");
						})

				}
			});
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
		},
		getCookie(name) {
			let reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
			let arr = document.cookie.match(reg)
			if (arr) {
				return unescape(arr[2]);
			}
			return '';
		},
		setCookie(name, value) {
			document.cookie = name + "=" + escape(value);
		}

	},
	mounted() {
		this.loginForm.userName = this.getCookie("username");
		// cookie存密码并不安全，暂时是为了方便
		this.loginForm.password = this.getCookie("password");
		const domain = window.location.hostname;
		this.$http({
			url: '/tenant/config',
			method: 'get',
			params: { type: 3, value: domain }
		}).then((data) => {
			if (!data) {
				return;
			}
			if (data.tenantName) {
				this.tenantName = data.tenantName;
			}
			if (data.tenantLogo) {
				this.tenantLogo = data.tenantLogo;
			}
			if (data.tenantId != null) {
				this.loginForm.tenantId = data.tenantId;
				sessionStorage.setItem('registerTenantId', String(data.tenantId));
			}
		}).catch(() => {});
	}
}
</script>

<style scoped lang="scss">
.login-view {
	width: 100%;
	height: 100%;
	box-sizing: border-box;
	background: radial-gradient(1200px 600px at 75% 55%, rgba(255, 200, 0, 0.18) 0%, rgba(255, 200, 0, 0) 60%),
		radial-gradient(900px 480px at 85% 50%, rgba(255, 170, 0, 0.16) 0%, rgba(255, 170, 0, 0) 62%),
		linear-gradient(135deg, #f6f7fb 0%, #eef1f7 50%, #f7f7fb 100%);
	overflow: hidden;
	position: relative;

	.bg-orb {
		position: absolute;
		border-radius: 50%;
		filter: blur(2px);
		opacity: 0.9;
		pointer-events: none;
	}

	.orb-1 {
		width: 520px;
		height: 520px;
		right: -160px;
		top: 80px;
		background: radial-gradient(circle at 30% 30%, rgba(255, 210, 68, 0.55), rgba(255, 210, 68, 0));
		animation: float 14s infinite ease-in-out;
	}

	.orb-2 {
		width: 360px;
		height: 360px;
		right: 120px;
		top: 260px;
		background: radial-gradient(circle at 40% 40%, rgba(255, 182, 0, 0.45), rgba(255, 182, 0, 0));
		animation: float 10s infinite ease-in-out reverse;
	}

	.orb-3 {
		width: 220px;
		height: 220px;
		right: 360px;
		bottom: -60px;
		background: radial-gradient(circle at 35% 35%, rgba(255, 210, 100, 0.38), rgba(255, 210, 100, 0));
		animation: float 12s infinite ease-in-out;
	}

	@keyframes float {
		0%,
		100% {
			transform: translateY(0) translateX(0) scale(1);
		}

		25% {
			transform: translateY(-28px) translateX(18px) scale(1.02);
		}

		50% {
			transform: translateY(18px) translateX(-22px) scale(0.98);
		}

		75% {
			transform: translateY(-14px) translateX(-16px) scale(1.01);
		}
	}

	@keyframes shimmer {
		0% { background-position: 0% 50%; }
		100% { background-position: 100% 50%; }
	}

	@keyframes iconFloat {
		0%, 100% { transform: translateY(0); filter: drop-shadow(0 4px 10px rgba(0,0,0,0.12)); }
		50% { transform: translateY(-4px); filter: drop-shadow(0 10px 18px rgba(0,0,0,0.16)); }
	}

	.shimmer {
		background: linear-gradient(90deg, rgba(0,0,0,0.86), rgba(255, 180, 0, 0.95), rgba(0,0,0,0.86));
		background-size: 200% 100%;
		-webkit-background-clip: text;
		background-clip: text;
		color: transparent;
		animation: shimmer 3.6s linear infinite;
	}

	.icon-float {
		animation: iconFloat 2.8s ease-in-out infinite;
	}

	.content {
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;
		height: 100%;
		padding: 0 6vw;

		.login-card {
			width: min(1020px, 92vw);
			height: 460px;
			display: grid;
			grid-template-columns: 1fr 1.15fr;
			border-radius: 16px;
			overflow: hidden;
			background: rgba(255, 255, 255, 0.92);
			box-shadow: 0 24px 60px rgba(0, 0, 0, 0.10);
			backdrop-filter: blur(8px);

			.card-left {
				position: relative;
				background: linear-gradient(180deg, #ffd200 0%, #ffcb00 55%, #ffbe00 100%);
				padding: 26px 26px 22px;
				display: flex;
				flex-direction: column;
				justify-content: space-between;
				color: rgba(255, 255, 255, 0.92);
			}

			.left-top {
				.welcome {
					font-size: 22px;
					font-weight: 800;
					letter-spacing: 1px;
					color: #fff;
				}
				.welcome-line {
					width: 38px;
					height: 3px;
					margin-top: 10px;
					background: rgba(255, 255, 255, 0.72);
					border-radius: 10px;
				}
			}

			.left-hero {
				position: relative;
				height: 250px;
				margin: 6px 0;

				.hero-surface {
					position: absolute;
					left: 12px;
					right: 12px;
					bottom: 14px;
					height: 76px;
					border-radius: 18px;
					background: rgba(255, 255, 255, 0.35);
					box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.55);
					filter: blur(0.2px);
				}

				.hero-fig {
					position: absolute;
					left: 32px;
					bottom: 42px;
					width: 120px;
					height: 170px;
					border-radius: 18px;
					background: linear-gradient(180deg, rgba(255,255,255,0.95), rgba(255,255,255,0.55));
					box-shadow: 0 18px 36px rgba(0, 0, 0, 0.10);
					transform: rotate(-6deg);
				}

				.hero-fig-2 {
					left: 112px;
					bottom: 34px;
					width: 140px;
					height: 190px;
					transform: rotate(8deg);
					opacity: 0.95;
				}
			}

			.left-bottom {
				.left-title {
					font-size: 16px;
					font-weight: 800;
					letter-spacing: 1px;
					color: #fff;
				}
				.left-sub {
					margin-top: 8px;
					font-size: 12px;
					color: rgba(255, 255, 255, 0.85);
				}
			}

			.card-right {
				padding: 34px 44px;
				display: flex;
				flex-direction: column;
				justify-content: center;
				background: rgba(255, 255, 255, 0.95);
			}

			.right-header {
				display: flex;
				align-items: center;
				gap: 12px;
				margin-bottom: 18px;
			}

			.right-icon {
				width: 34px;
				height: 34px;
				border-radius: 8px;
				object-fit: cover;
				background: #fff;
			}

			.right-title {
				font-size: 22px;
				font-weight: 800;
				letter-spacing: 1px;
				color: rgba(0, 0, 0, 0.86);
			}

			.right-subtitle {
				font-size: 12px;
				color: rgba(0, 0, 0, 0.55);
				margin-bottom: 16px;
			}

			.form {
				::v-deep .el-input__inner {
					height: 40px;
					line-height: 40px;
					border-radius: 8px;
				}
			}

			.btn-row {
				margin-top: 6px;
			}

			.btn-login {
				width: 100%;
				height: 40px;
				border-radius: 8px;
				font-weight: 700;
				background: #ffd200;
				border-color: #ffd200;
				color: rgba(0, 0, 0, 0.86);
			}
		}
	}
}
</style>
